import React from "react"
import Image from "next/image"

import SiteHeader from "@components/SiteHeader"
import AFFSidebarLayout from "./AFFSidebarLayout"

const AFFAuthPageLayout: React.FunctionComponent<{ onLogout?: () => void }> = ({ onLogout, children }) => (
    <>
        <SiteHeader />
        <AFFSidebarLayout
            onLogout={onLogout}>
            <div className="flex text-center">
                <div className="w-full sm:w-1/2 h-full p-8">
                    {children}
                </div>

                <div className="hidden sm:block sm:w-1/2 relative min-h-[72vh] bg-primary-600">
                    <Image layout="fill" objectFit="cover" src="/images/bg_authentication_deco.svg" alt="Decoration" priority={true} />
                </div>
            </div>
        </AFFSidebarLayout>
    </>
)

export default AFFAuthPageLayout
